import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ContentDisplay = ({ activeTab, tabData, variant = 'light' }) => {
  const currentTab = tabData.find(tab => tab.id === activeTab);
  const isDark = variant === 'dark';

  const containerVariants = {
    hidden: { 
      opacity: 0,
      y: 20,
      scale: 0.95
    },
    visible: { 
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        staggerChildren: 0.1
      }
    },
    exit: { 
      opacity: 0,
      y: -20,
      scale: 0.95,
      transition: {
        duration: 0.3,
        ease: "easeIn"
      }
    }
  };

  const itemVariants = {
    hidden: { 
      opacity: 0,
      y: 20
    },
    visible: { 
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };

  if (!currentTab) return null;

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={activeTab}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        className="text-center space-y-6"
      >
        {/* 主标题 */}
        <motion.h1 
          variants={itemVariants}
          className={`text-3xl sm:text-4xl md:text-5xl font-semibold leading-tight tracking-tight pb-2 ${isDark ? 'text-white' : 'text-slate-900'}`}
          style={{ 
            lineHeight: '1.2',
            paddingBottom: '0.125rem'
          }}
        >
          {currentTab.title}
        </motion.h1>

        {/* 副标题 */}
        <motion.p 
          variants={itemVariants}
          className={`text-lg md:text-xl max-w-2xl mx-auto leading-relaxed ${isDark ? 'text-slate-300' : 'text-slate-600'}`}
        >
          {currentTab.subtitle}
        </motion.p>
      </motion.div>
    </AnimatePresence>
  );
};

export default ContentDisplay;